import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_c3c92pgxh3: FaireBrandEntity = {
  token: "b_c3c92pgxh3",
  type: "brand",
  name: "Lumpy Studios LLC",
  avatarUrl:
    "https://cdn.faire.com/fastly/362be4f0f0d10c0613325a2309f356c3977f9bd79cc576a891e5ca06367792af.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/0ce713f1a9964a06f9c0493646f09cc89668d3854155f9fa4028c4da445c5d86.png",
  logoUrl:
    "https://cdn.faire.com/fastly/362be4f0f0d10c0613325a2309f356c3977f9bd79cc576a891e5ca06367792af.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/0ce713f1a9964a06f9c0493646f09cc89668d3854155f9fa4028c4da445c5d86.png",
  location: "Philadelphia, PA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Lumpy grew out of the small moments that made us — wandering through Asian markets as kids, soaking in the colors, the textures, the smell of the fish counter that hit you before you even turned the corner. That feeling stuck with us, and honestly, it never left.\n\nWe design stuff that celebrates nostalgia. Things that feel familiar but a little fresh — designed with care, made with intention, and sprinkled with some silliness. We think a lot about form, material, and what makes an object actually feel like something.\n\nWe're big fans of the imperfect. The lopsided, the a-little-off, the \"that's not quite right but why does it still work.\" Things that are proudly, unapologetically a little lumpy.\n\nThis is our love letter to where we came from. Thoughtful but not too serious. Playful but made with real care. We hope something in our work makes you pause, feel a little seen, or just makes you laugh.\n\nNow come get these lumps, baby!",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:07.888Z",
    importedBy: "entity-db-cli",
  },
};
